import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/**
 * The restaurant whose deliveries are shown. Persisted (mirroring `count-restaurant-store`) so
 * a staff member checking a delivery on a phone comes back to the same location after a reload
 * instead of the first restaurant of the tenant.
 */
interface DeliveryRestaurantState {
  restaurantId: number | null
  setRestaurantId: (id: number | null) => void
}

export const useDeliveryRestaurantStore = create<DeliveryRestaurantState>()(
  persist(
    (set) => ({
      restaurantId: null,
      setRestaurantId: (id) => set({ restaurantId: id }),
    }),
    { name: 'inventory-delivery-restaurant' },
  ),
)
